export default __webpack_public_path__ + "static/media/sponsor1.5fafe868.png";